"use client"

import { ReactElement, ReactNode } from "react"

// Story 3.3 — Botão de ação primária do checkout (dark, tokens VE). Variante `paypal`
// usa a cor de marca do PayPal para o CTA de pagamento (redirect, AD-11).

type CheckoutButtonProps = {
  children: ReactNode
  onClick?: () => void
  type?: "button" | "submit"
  disabled?: boolean
  loading?: boolean
  variant?: "primary" | "paypal"
  "data-testid"?: string
}

export default function CheckoutButton({
  children,
  onClick,
  type = "button",
  disabled = false,
  loading = false,
  variant = "primary",
  "data-testid": dataTestId,
}: CheckoutButtonProps): ReactElement {
  const palette =
    variant === "paypal"
      ? "bg-[#ffc439] text-[#003087] hover:brightness-95"
      : "bg-accent-strong text-white hover:bg-accent-hover"

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      data-testid={dataTestId}
      className={`inline-flex h-11 items-center justify-center gap-2 rounded-rounded px-6 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${palette}`}
    >
      {loading ? "Processando..." : children}
    </button>
  )
}
